import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import apiClient from '../../api/axios';

const DriverLogin = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Prevent any authentication interference
  useEffect(() => {
    console.log('🚛 Driver Test Login - Current path:', location.pathname);
    // Clear any existing user session for testing
    sessionStorage.removeItem('user');
    localStorage.removeItem('user');
  }, [location.pathname]);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // First try to verify test data if needed
      try {
        await apiClient.post('/driver-test-enhanced/create-test-data-simple');
        console.log('✅ Test data verified');
      } catch (testDataError) {
        console.log('Test data check skipped:', testDataError.response?.data?.message);
      }

      // Attempt login with backend API
      const response = await apiClient.post('/driver/login', formData);

      if (response.data.status === 'success') {
        // Store driver info in localStorage for testing
        localStorage.setItem('driver_token', response.data.token);
        localStorage.setItem('driver_info', JSON.stringify(response.data.driver));
        
        toast.success(`Welcome ${response.data.driver.name}! Login successful!`);
        navigate('/driver-test/dashboard');
      } else {
        toast.error(response.data.message || 'Login failed');
      }
    } catch (error) {
      console.log('Login error, attempting fallback:', error);
      
      // If API fails, try to get existing drivers and simulate login
      try {
        const driversResponse = await apiClient.get('/driver-test-enhanced/all-drivers');
        const drivers = driversResponse.data.data;
        
        if (drivers && drivers.length > 0) {
          // Use the first available driver for testing
          const testDriver = drivers[0];
          
          localStorage.setItem('driver_token', 'test_token_' + Date.now());
          localStorage.setItem('driver_info', JSON.stringify({
            driver_id: testDriver.driver_id,
            name: testDriver.name,
            phone: testDriver.phone,
            email: testDriver.email
          }));
          
          toast.success(`Test login successful as ${testDriver.name}!`);
          navigate('/driver-test/dashboard');
        } else {
          // Create a mock driver session as last resort
          const mockDriver = {
            driver_id: Math.floor(Math.random() * 100) + 1,
            name: 'Test Driver',
            phone: formData.phone,
            email: 'test@driver.com'
          };
          
          localStorage.setItem('driver_token', 'test_token_' + Date.now());
          localStorage.setItem('driver_info', JSON.stringify(mockDriver));
          
          toast.success('Mock driver session created for testing!');
          navigate('/driver-test/dashboard');
        }
      } catch (fallbackError) {
        console.error('All login methods failed:', fallbackError);
        toast.error('Unable to connect to backend. Please check if the server is running.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <div className="row justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="col-md-6 col-lg-4">
          <div className="card shadow-lg">
            <div className="card-header bg-primary text-white text-center">
              <h4 className="mb-0">
                <i className="ri-truck-line me-2"></i>
                Driver Login
              </h4>
              <small>Testing Portal</small>
            </div>
            <div className="card-body p-4">
              <form onSubmit={handleLogin}>
                <div className="mb-3">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter email address"
                    required
                  />
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    placeholder="Enter password"
                    required
                  />
                </div>

                <div className="alert alert-info">
                  <i className="ri-information-line me-2"></i>
                  <strong>Available Test Accounts:</strong><br/>
                  • john.driver@example.com<br/>
                  • alex.rider@example.com<br/>
                  • sam.delivery@example.com<br/>
                  <small>Password: <strong>password123</strong></small>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                      Logging in...
                    </>
                  ) : (
                    <>
                      <i className="ri-login-circle-line me-2"></i>
                      Login as Driver
                    </>
                  )}
                </button>
              </form>

              <div className="mt-4 text-center">
                <small className="text-muted">
                  This is a testing interface for driver assignment functionality
                </small>
                <div className="mt-2">
                  <a href="/" className="text-primary">
                    ← Back to Main Application
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverLogin; 